import React from 'react'
import { Container, Image, Segment, TextArea } from 'semantic-ui-react'

import edit from '../../assets/images/edit-small.png'
import { tr } from '../../helpers/languages'

const NextReminder = (props) => {
    return (
        <Container className='session-next-reminder'>
            <Segment className='section-title'>
                {tr('REMINDER')}
                <span className='for-next-week'>{tr('FOR_NEXT_SESSION')}</span>
                {
                    !props.editable && (
                        <Image src={edit} onClick={(_e) => { props.onToggleEditing() }}/>
                    )
                }
            </Segment>
            <Segment className='next-reminder'>
                <TextArea
                    disabled={!props.editable}
                    placeholder={tr('KEEP_HERE_REMINDERS')}
                    maxLength={900}
                    value={props.session.reminder ? props.session.reminder : ''}
                    onChange={(e) => { props.onChangeValue('reminder', e.target.value) }}
                />
            </Segment>
        </Container>
    )
}

export default NextReminder



// WEBPACK FOOTER //
// ./src/components/participant-session/next-reminder.js